module.exports = __webpack_public_path__ + "static/sustainability-impact-landing-hero-mobile.b7709c18.webp";